import { render, staticRenderFns } from "./BlockDropdowns.vue?vue&type=template&id=766b40fc&"
import script from "./BlockDropdowns.vue?vue&type=script&lang=js&"
export * from "./BlockDropdowns.vue?vue&type=script&lang=js&"
import style0 from "./BlockDropdowns.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports